import { cn } from '@forest/shared'
import type { CSSProperties, ReactNode, Ref } from 'react'
import '~/styles/gradient-border.css'

type Size = number | string

export type Props = {
  children?: ReactNode
  className?: string
  style?: CSSProperties
  borderWidth?: Size
  radius: Size
  gradient?: string
  ref?: Ref<HTMLSpanElement>
}

export function GradientBorderBox({
  children,
  className,
  style,
  borderWidth = 1.5,
  radius,
  gradient = 'linear-gradient(90deg, #FFFFFF4D, #FFFFFF1A)',
  ref,
  ...restProps
}: Props & Record<string, unknown>) {
  const cssVars: CSSProperties = {
    ['--border-width' as any]:
      typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,
    ['--radius' as any]: typeof radius === 'number' ? `${radius}px` : radius,
    ['--gradient' as any]: gradient,
  }

  return (
    <span
      ref={ref}
      className={cn('gradient-border relative', className)}
      style={{ ...cssVars, ...style }}
      {...restProps}
    >
      {children}
    </span>
  )
}
